import axios, { AxiosPromise } from 'axios';

import { ETypUdalosti } from 'enums/akcionarKorpAkce/typUdalosti';

const stahnoutKorporatniAkciApi = (
    id: string,
    typodp: ETypUdalosti.VHODP | ETypUdalosti.VYPISODP
): AxiosPromise<{ redirect: string }> => {
    return axios({
        method: 'GET',
        url: `SRD/${id}/ZIP`,
        params: {
            typodp
        }
    });
};
export default stahnoutKorporatniAkciApi;
